import React from 'react'

import GlobalSnackbar, { GlobalSnackbarProps } from '../components/GlobalSnackbar'

interface AppProviderProps {
  children: React.ReactNode
}

interface AppContextInterface {
  globalSnackbarProps: GlobalSnackbarProps | null
  setGlobalSnackbarProps: React.Dispatch<React.SetStateAction<GlobalSnackbarProps | null>>
  showHeaderLoader: boolean
  setShowHeaderLoader: React.Dispatch<React.SetStateAction<boolean>>
}

const AppContext = React.createContext<AppContextInterface>({} as AppContextInterface)

export function AppProvider({ children }: AppProviderProps): JSX.Element {
  const [globalSnackbarProps, setGlobalSnackbarProps] = React.useState<GlobalSnackbarProps | null>(null)
  const [showHeaderLoader, setShowHeaderLoader] = React.useState(false)

  const appContext: AppContextInterface = {
    globalSnackbarProps,
    setGlobalSnackbarProps,
    showHeaderLoader,
    setShowHeaderLoader,
  }

  return (
    <AppContext.Provider value={appContext}>
      {children}

      {globalSnackbarProps && (
        <GlobalSnackbar {...globalSnackbarProps} />
      )}
    </AppContext.Provider>
  )
}

export default function useAppContext(): AppContextInterface {
  return React.useContext(AppContext)
}
